module.exports = __webpack_public_path__ + "static/191015-BS-IGB-HM1-Pet-Pouch-Shiba-52640fc24f5fa5f79072a3e53ba86518.jpg";